import { ErrorBoundary } from '@vp/swan';
import React from 'react';

const PriceErrorBoundary = ({ children, fallbackUi }) => {
  return /* @__PURE__ */ React.createElement(ErrorBoundary, { fallback: fallbackUi }, children);
};

export { PriceErrorBoundary as default };
//# sourceMappingURL=src-components-PriceErrorBoundary.js.map
